export const isTouchableDevice = () => 'ontouchstart' in window;
